import { useTranslation } from 'react-i18next';
import type { DynamicPricingCalendarDay } from '@/shared/api';
import { PriceDerivation } from '../PriceDerivation';
import { TRIGGER } from '../history/historyText';
import { CHANGED } from '../priceDerivationModel';

const UNREADABLE_CONTRIBUTIONS = 'pricing_calendar_contribution_data_invalid';

/** Berechnung eines Tages – dieselbe Herleitung wie im Verlauf (`PriceDerivation`). */
export function DynamicPricingCalculationSection({ day }: { day: DynamicPricingCalendarDay }) {
  const { t } = useTranslation();
  const decision = day.decision;
  return (
    <section className="border-line space-y-2 border-t pt-4">
      <h3 className="font-serif text-lg">
        {t('admin.dynamicPricing.calendar.details.calculation')}
      </h3>
      {decision ? (
        <>
          <p className="text-ink-soft text-sm">
            Auslöser: {TRIGGER[decision.trigger] ?? decision.trigger}{' '}
            {/* Ohne Änderung nennt die Herleitung den Grund samt Code selbst. */}
            {CHANGED.has(decision.outcome) && (
              <code className="font-mono text-[11px]">{decision.reasonCode}</code>
            )}
          </p>
          <PriceDerivation
            // Der Server meldet unlesbare Beiträge als Hinweis; die Herleitung sagt dann
            // „nicht lesbar“ statt „keine Beiträge“.
            source={
              day.warningCodes.includes(UNREADABLE_CONTRIBUTIONS)
                ? { ...decision, contributions: null }
                : decision
            }
            minimumStay={decision.minimumStayExplanation}
          />
        </>
      ) : (
        <p className="text-ink-soft text-sm">
          {t('admin.dynamicPricing.calendar.details.noMaterialDecision')}
        </p>
      )}
    </section>
  );
}
